import React from 'react'
import { Outlet } from 'react-router-dom'


const SmartTokenLayout = () => {
  return (
    <>
        <Outlet />
    </>
  )
}

export default SmartTokenLayout